BookingApp.service('BusService',['$http','$filter',function($http,$filter){
	var data = { buses:[],status:'Not-Set' };
	var RouteDetail ;
	var SeatLayout ;
	var selectedBus;
	var selectedSeats = [];
	var routeId;
	var AllOperators = [];
	var AllBoardingPoints = [];
	var BusTypes = [];
	var MinPrice = 1000000;
	var MaxPrice = 0;

		
	this.getData = function(request){
		return $http({
			url:'buses/search',
			method:'post',
			data:request
		}).then(function(response){
				data = response.data;	
				return data;
			},function(response){
				return response.data;
		});
	}
	
	this.getSeatData = function(param){
		return $http({
			url:'buses/' + param.SessionId + '/' + param.RouteId,
			method:'post',
			headers:{
				'X-Requested-With':'XMLHttpRequest',
			}
		}).then(function(r){
			return r.data;
				SeatLayout = r.data.SeatLayout;
				RouteDetail = r.data.RouteDetail;
				return r.data.SeatLayout;
			},function(r){
				return false;
		});
	}
	
	this.setFilterData = function(buses,filterName){
		//return blank array if not set
		if(!buses.length) return [];
		
		angular.forEach(buses,function(bus,index){
			//Set Operators
			if(filterName == 'all' || filterName == 'operator'){
				if(index == 0) AllOperators = [];
				if(AllOperators.indexOf(bus.TravelName) === -1){
					AllOperators.push(bus.TravelName);
				}
			}
			
			//Setb Boarding Points
			if(filterName == 'all' || filterName == 'boardingPoints' ){
				if(index == 0) AllBoardingPoints = [];
				angular.forEach(bus.boardingPoints , function(value){
					if(AllBoardingPoints.indexOf(value.CityPointLocation) === -1){
						AllBoardingPoints.push(value.CityPointLocation);
					}
				})
			}
			
			//SetBus Type
			if(filterName == 'all' || filterName == 'busType' ){
				if(index == 0) BusTypes = [];	
				if(BusTypes.indexOf(bus.BusType) === -1){
					BusTypes.push(bus.BusType);
				}
			}
			
			if(filterName == 'all' || filterName == 'price' ){
				//Set MinPrice
				if(parseInt(bus.AvailableFares) > MaxPrice){
					 MaxPrice = parseInt(bus.AvailableFares);
				}
				
				//Set MaxPrice
				if(parseInt(bus.AvailableFares) < MinPrice){
					MinPrice = parseInt(bus.AvailableFares);
				}
			}
			
		});
	}
	
	this.checkConditions = function(type, ScopeVar,history){
		console.log("Conditions var => [ type => " + type + " , ScopeVar => " + ScopeVar + " , history => " + history);
		if(type == 'OperatorFilter'){ 
			//console.log(ScopeVar != 'Operators');
			//console.log(this.checkInHistory(type,ScopeVar,history));
			return (ScopeVar != 'Operators')  && this.checkInHistory(type,ScopeVar,history);
		};
		if(type == 'TypeFilter'){
			//console.log((ScopeVar != 'BusTypes'));
			//console.log(this.checkInHistory(type,ScopeVar,history));
			return (ScopeVar != 'BusTypes') && this.checkInHistory(type,ScopeVar,history);
		}
	}
	
	this.checkInHistory = function(type,ScopeVar,history){
		if(ScopeVar == 'Operators')	return history.indexOf('OperatorFilter') === -1;
		if(ScopeVar == 'BusTypes')	return history.indexOf('TypeFilter') === -1;		
		return true;
	}
	this.getRouteBordingPoints  = function(){ return angular.isDefined(RouteDetail.BoardingPoints) ? RouteDetail.BoardingPoints : false;}
	this.getRouteDroppingPoints  = function(){ return angular.isDefined(RouteDetail.DroppingPoints) ? RouteDetail.DroppingPoints : false;}
	this.getOperators 			= function(){		return AllOperators;	}		
	this.getAllBoardingPoints 	= function(){		return AllBoardingPoints;	}	
	this.getAllBusType 			= function(){		return BusTypes;	}	
	this.getPrice 				= function(type){	return (type == 'min') ? MinPrice : MaxPrice;	}		
	this.getDOJ 				= function(){ 		return request.DateOfJourney; }
	this.getSource 				= function(){ 		return request.SourceName; }
	this.getDestination 		= function(){ 		return request.DestinationName; }
}]);